import { call, takeLatest } from "redux-saga/effects";

import {
  CUSTOM_FUNCTION_VALIDATE,
  CUSTOM_FUNCTION_SAVE,
  CUSTOM_FUNCTION_LIST,
  CUSTOM_FUNCTION_GET,
  CUSTOM_FUNCTION_UPDATE,
  CUSTOM_FUNCTION_DELETE,
} from "../types";
import {
  customFunctionValidateApi,
  customFunctionSaveApi,
  customFunctionListApi,
  customFunctionGetApi,
  customFunctionUpdateApi,
  customFunctionDeleteApi,
} from "../apis/custom-function-api";

export function* customFunctionValidateWorker(action) {
  try {
    const res = yield call(customFunctionValidateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionSaveWorker(action) {
  try {
    const res = yield call(customFunctionSaveApi, action.data);
    if (res.status === 200 || res.status === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionListWorker(action) {
  try {
    const res = yield call(customFunctionListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionGetWorker(action) {
  try {
    const res = yield call(customFunctionGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionUpdateWorker(action) {
  try {
    const res = yield call(customFunctionUpdateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionDeleteWorker(action) {
  try {
    const res = yield call(customFunctionDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customFunctionValidateWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_VALIDATE, customFunctionValidateWorker);
}

export function* customFunctionSaveWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_SAVE, customFunctionSaveWorker);
}

export function* customFunctionListWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_LIST, customFunctionListWorker);
}

export function* customFunctionGetWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_GET, customFunctionGetWorker);
}

export function* customFunctionUpdateWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_UPDATE, customFunctionUpdateWorker);
}

export function* customFunctionDeleteWatcher() {
  yield takeLatest(CUSTOM_FUNCTION_DELETE, customFunctionDeleteWorker);
}
